import Vue from 'vue'
import Router from 'vue-router'
import { Store } from '../RF_store/index'
import Bugsnag from '../plugins/bugsnag'
import PartnerOnboarding from '../views/PartnerOnboarding/PartnerOnboarding.vue'
import PartnerWelcome from '../views/PartnerOnboarding/PartnerWelcome.vue'
import PartnerBusiness from '../views/PartnerOnboarding/PartnerBusiness.vue'
import mixpanel from '../plugins/mixPanel'
import AddOwner from '../views/AddOwner.vue'

Vue.use(Router)

function lazyLoad (view) {
  return () => import(`../views/${view}.vue`)
}

const routes = [
  // Happy Flow Partner Onboarding
  {
    path: '/',
    name: 'PartnerObWrapper',
    component: PartnerOnboarding,
    children: [
      {
        path: '',
        name: 'partner-welcome',
        component: PartnerWelcome,
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '1' })
          handleNext(from, next)
        }
      },
      {
        path: '/partner/business',
        name: 'partner-business',
        component: PartnerBusiness,
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '2' })
          handleNext(from, next)
        }
      },
      {
        path: '/partner/add-owner',
        name: 'addOwner',
        component: AddOwner
      },
      {
        path: '/partner/account-type',
        name: 'plan',
        component: lazyLoad('rf_plan'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '3' })
          handleNext(from, next)
        }
      },
      {
        path: '/partner/confirmDetails',
        component: lazyLoad('rf_review'),
        name: 'review',
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '4' })
          handleNext(from, next)
        }
      },
      {
        path: '/partner/approved',
        component: lazyLoad('rf_approved'),
        name: 'approved',
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '4' })
          handleNext(from, next)
        }
      },
      {
        path: '/partner/kybPending',
        name: 'kybPending',
        component: () => import('../views/kybViews/kybPending.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/kybThankYou',
        name: 'kybThankYou',
        component: () => import('../views/kybViews/kybThankYou.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/verificationCenter',
        name: 'verificationCenter',
        component: () => import('../views/kybViews/VerificationCenterV2/VerificationCenterV2.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/noContinueDone',
        name: 'noContinueDone',
        component: () => import('../views/kycFailedViews/NoContinueDone.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/noContinueChecking',
        name: 'noContinueChecking',
        component: () => import('../views/kycFailedViews/NoContinueChecking.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/error',
        name: 'generalError',
        component: () => import('../views/kycFailedViews/GeneralError.vue')
      },
      {
        path: '/partner/noContinuePrimary',
        name: 'ContinueOtherBusiness',
        component: () => import('../views/PartnerOnboarding/ContinueOtherBusiness.vue')
      },
      {
        path: '/partner/debitCardName',
        name: 'DebitCardName',
        component: () => import('../views/kycFailedViews/DebitCardName.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/checkDocs',
        name: 'checkDocs',
        component: () => import('../views/kycFailedViews/CheckDocks.vue'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
          next()
        }
      },
      {
        path: '/partner/alreadyHaveAccount',
        name: 'accountExists',
        component: lazyLoad('rf_approved'),
        beforeEnter: (to, from, next) => {
          Store.commit('onboarding/setKeyValue', { prop: 'hasAccount', value: true })
          next()
        }
      }
    ]
  },
  { path: '*', name: 'not found', component: PartnerWelcome }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior () {
    window.scrollTo(0, 0)
  }
})

// Before enter to any route, do something
router.beforeEach((to, from, next) => {
  // Report page view
  mixpanel.track('Page Viewed', {
    page: to.path,
    origin: from.fullPath,
    pageName: to.name,
    query: from.fullPath
  })
  // Make sure to clean default error msg from module
  Store.dispatch('errors/setFieldContent', {
    field: 'defaultError',
    content: ''
  })
  // Save last route origin
  Store.commit('customer/setKeyValue', {
    prop: 'fromRoute',
    value: from.fullPath
  })
  // Avoid duplicate navigation
  if (to.name === from.name && to.query === from.query) {
    next(false)
  } else {
    next()
  }
})

const isFromFailedKycView = viewName => {
  const views = Store.getters['onboarding/data'].failedKycRoutes
  return views.includes(viewName)
}

const handleNext = (from, next) => {
  if (isFromFailedKycView(from.name)) {
    next({
      name: 'welcome',
      query: { should_persist: false }
    })
  } else {
    next()
  }
}

// On error failure notify to bugsnag
router.onError(err => {
  Bugsnag.notify(JSON.stringify(err))
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js